module.exports = __webpack_public_path__ + "static/img/pro1-3.a2d1075.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/pro1-3.png
// module id = mzvj
// module chunks = 0